"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaWalletService = void 0;
var proto_signing_1 = require("@cosmjs/proto-signing");
var crypto_1 = require("@cosmjs/crypto");
var FirmaUtil_1 = require("./FirmaUtil");
var LedgerWallet_1 = require("./firmachain/common/LedgerWallet");
var amino_1 = require("@cosmjs/amino");
var CryptoJS = require("crypto-js");
var FirmaWalletService = /** @class */ (function () {
    function FirmaWalletService(config) {
        this.config = config;
        this.mnemonic = "";
        this.privateKey = "";
        this.accountIndex = 0;
    }
    FirmaWalletService.prototype.getHdPath = function () {
        return this.config.hdPath;
    };
    FirmaWalletService.prototype.getPrefix = function () {
        return this.config.prefix;
    };
    FirmaWalletService.prototype.getRawWallet = function () {
        return this.wallet;
    };
    FirmaWalletService.prototype.getRawAminoWallet = function () {
        return this.aminoWallet;
    };
    FirmaWalletService.prototype.getPrivateKey = function () {
        return this.privateKey;
    };
    FirmaWalletService.prototype.getMnemonic = function () {
        return this.mnemonic;
    };
    FirmaWalletService.prototype.isLedger = function () {
        return (this.ledger != null);
    };
    FirmaWalletService.prototype.initFromLedger = function (ledger) {
        return __awaiter(this, void 0, void 0, function () {
            var wallet;
            return __generator(this, function (_a) {
                try {
                    wallet = new FirmaWalletService(this.config);
                    wallet.ledger = ledger;
                    return [2 /*return*/, wallet];
                }
                catch (error) {
                    FirmaUtil_1.FirmaUtil.printLog(error);
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    FirmaWalletService.prototype.signLedger = function (messages, option, registry) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, LedgerWallet_1.signFromLedger(this.ledger, messages, option, registry)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FirmaWalletService.prototype.getPubKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, accounts, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        if (!(this.ledger != null)) return [3 /*break*/, 2];
                        _b = (_a = FirmaUtil_1.FirmaUtil).arrayBufferToBase64;
                        return [4 /*yield*/, this.ledger.getPublicKey()];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                    case 2: return [4 /*yield*/, this.wallet.getAccounts()];
                    case 3:
                        accounts = _c.sent();
                        return [2 /*return*/, FirmaUtil_1.FirmaUtil.arrayBufferToBase64(accounts[0].pubkey)];
                    case 4:
                        error_1 = _c.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.getAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accounts, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(this.ledger != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ledger.getAddress()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.wallet.getAccounts()];
                    case 3:
                        accounts = _a.sent();
                        return [2 /*return*/, accounts[0].address];
                    case 4:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.getHdPath = function (hdPath, accountIndex) {
        try {
            return [crypto_1.stringToPath(hdPath + accountIndex + "'/0/0")];
        }
        catch (error) {
            FirmaUtil_1.FirmaUtil.printLog(error);
            throw error;
        }
    };
    FirmaWalletService.prototype.initFromMnemonic = function (mnemonic, accountIndex) {
        if (accountIndex === void 0) { accountIndex = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var privateKey, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.mnemonic = mnemonic;
                        this.accountIndex = accountIndex;
                        return [4 /*yield*/, this.getPrivateKeyInternal(this.mnemonic, this.accountIndex)];
                    case 1:
                        privateKey = _a.sent();
                        return [4 /*yield*/, this.initFromPrivateKey(privateKey)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, { success: true }];
                    case 3:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.getPrivateKeyInternal = function (mnemonic, accountIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var mnemonicChecked, seed, hdpath, privkey, privateKey, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        mnemonicChecked = new crypto_1.EnglishMnemonic(mnemonic);
                        return [4 /*yield*/, crypto_1.Bip39.mnemonicToSeed(mnemonicChecked)];
                    case 1:
                        seed = _a.sent();
                        hdpath = FirmaWalletService.getHdPath(this.getHdPath(), accountIndex);
                        privkey = crypto_1.Slip10.derivePath(crypto_1.Slip10Curve.Secp256k1, seed, hdpath[0]).privkey;
                        privateKey = "0x" + Buffer.from(privkey).toString("hex");
                        return [2 /*return*/, privateKey];
                    case 2:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.initFromPrivateKey = function (privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            var tempPrivateKey, _a, _b, error_5;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        tempPrivateKey = Buffer.from(privateKey.replace("0x", ""), "hex");
                        _a = this;
                        return [4 /*yield*/, proto_signing_1.DirectSecp256k1Wallet.fromKey(tempPrivateKey, this.getPrefix())];
                    case 1:
                        _a.wallet = _c.sent();
                        _b = this;
                        return [4 /*yield*/, amino_1.Secp256k1Wallet.fromKey(tempPrivateKey, this.getPrefix())];
                    case 2:
                        _b.aminoWallet = _c.sent();
                        this.privateKey = privateKey;
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _c.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.decryptData = function (data) {
        try {
            var bytes = CryptoJS.AES.decrypt(data, this.getPrivateKey());
            return bytes.toString(CryptoJS.enc.Utf8);
        }
        catch (error) {
            FirmaUtil_1.FirmaUtil.printLog(error);
            throw error;
        }
    };
    FirmaWalletService.prototype.encryptData = function (data) {
        try {
            return CryptoJS.AES.encrypt(data, this.getPrivateKey()).toString();
        }
        catch (error) {
            FirmaUtil_1.FirmaUtil.printLog(error);
            throw error;
        }
    };
    FirmaWalletService.prototype.newWallet = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mnemonic, wallet, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.generateMnemonic()];
                    case 1:
                        mnemonic = _a.sent();
                        return [4 /*yield*/, this.fromMnemonic(mnemonic)];
                    case 2:
                        wallet = _a.sent();
                        return [2 /*return*/, wallet];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.fromMnemonic = function (mnemonic, accountIndex) {
        if (accountIndex === void 0) { accountIndex = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var wallet, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        wallet = new FirmaWalletService(this.config);
                        return [4 /*yield*/, wallet.initFromMnemonic(mnemonic, accountIndex)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, wallet];
                    case 2:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.fromPrivateKey = function (privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            var wallet, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        wallet = new FirmaWalletService(this.config);
                        return [4 /*yield*/, wallet.initFromPrivateKey(privateKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, wallet];
                    case 2:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaWalletService.prototype.generateMnemonic = function () {
        return __awaiter(this, void 0, void 0, function () {
            var wallet, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, proto_signing_1.DirectSecp256k1HdWallet.generate(24)];
                    case 1:
                        wallet = _a.sent();
                        return [2 /*return*/, wallet.mnemonic];
                    case 2:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaWalletService;
}());
exports.FirmaWalletService = FirmaWalletService;
